import { AjaxDataTypes } from '../../../../shared/AjaxDataTypes.ts';
import { LobbyImage } from '@colonist/types';
import { notificationController } from '../EntryShared.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { ClientUserState } from '../ClientUserState.ts';
export class UIUtilsFriends {
    static async addFriendAction(usernameToAdd, onSuccessAction) {
        const friendChangeData = {
            username: usernameToAdd
        };
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiUserProfileAddFriend(), undefined, friendChangeData, 'application/json');
        if (response == undefined) return;
        void ClientUserState.refresh();
        const friendData = response.json;
        const becameFriends = friendData.friends.some((friend)=>friend.username == usernameToAdd);
        const notificationKey = becameFriends ? {
            key: 'strings:popups.notification.youAreNowFriendsWith',
            options: {
                username: usernameToAdd
            }
        } : {
            key: 'strings:profilePage.friends.friendRequestSent'
        };
        notificationController.showNotification(LobbyImage.Friends, notificationKey);
        if (onSuccessAction) onSuccessAction(becameFriends);
        for (const callback of UIUtilsFriends.callbackActionOnFriendRequestSent){
            callback();
        }
    }
    static async removeFriendAction(usernameToRemove, onSuccessAction) {
        const friendChangeData = {
            username: usernameToRemove
        };
        const postRequestResult = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiUserProfileRemoveFriend(), undefined, friendChangeData, 'application/json');
        if (postRequestResult == undefined) return;
        void ClientUserState.refresh();
        notificationController.showNotification(LobbyImage.Friends, {
            key: 'strings:popups.friendRequests.removed',
            options: {
                username: usernameToRemove
            }
        });
        if (typeof onSuccessAction == 'function') {
            onSuccessAction();
        }
    }
    static showRemoveFriendPopup(usernameToRemove, removeFriendPopupAction) {
        const removeFriendPopupTitle = {
            key: 'strings:profilePage.friends.removeFriend.title'
        };
        const removeFriendPopupBody = {
            key: 'strings:profilePage.friends.removeFriend.body',
            options: {
                username: usernameToRemove
            }
        };
        showSimpleDialog({
            title: removeFriendPopupTitle,
            body: removeFriendPopupBody,
            onConfirm: removeFriendPopupAction,
            showCancelBtn: true
        });
    }
    static async getFriends(currentUserState) {
        if (!(currentUserState === null || currentUserState === void 0 ? void 0 : currentUserState.isLoggedIn)) return new AjaxDataTypes.UserFriendsData();
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.friends(), undefined);
        if (response == undefined) return new AjaxDataTypes.UserFriendsData();
        return response.json;
    }
    static async getFriendRequestsReceived(currentUserState) {
        if (!(currentUserState === null || currentUserState === void 0 ? void 0 : currentUserState.isLoggedIn)) return [];
        const friendRequestsResponse = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFriendRequestsReceived(), undefined);
        if (friendRequestsResponse == undefined) return [];
        return friendRequestsResponse.json;
    }
    static async friendRequestResponded(target, isAccepted) {
        const friendChangeData = target.userId != undefined ? {
            userId: target.userId
        } : {
            username: target.username
        };
        const api = isAccepted ? UIAPIEndpoints.apiUserProfileAcceptFriend() : UIAPIEndpoints.apiUserProfileRemoveFriend();
        const response = await UIAjaxWrapper.postRequestHandler(api, undefined, friendChangeData, 'application/json');
        if (response == undefined) return;
        void ClientUserState.refresh();
        for (const callback of UIUtilsFriends.callbackNotificationFriendRequestResponded){
            await callback(target, isAccepted);
        }
    }
    static canUseOnlineFriendService() {
        var _ClientUserState_userState;
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) return false;
        return true;
    }
    static setCallbackFriendRequestResponded(callback) {
        UIUtilsFriends.callbackNotificationFriendRequestResponded.push(callback);
    }
}
UIUtilsFriends.callbackActionOnFriendRequestSent = [];
UIUtilsFriends.callbackNotificationFriendRequestResponded = [];
